import {
	ADD_RECENT_CHATS_REQUEST,
	ADD_RECENT_CHATS_SUCCESS,
	ADD_RECENT_CHATS_FAILURE
} from "../../constants";

import { pharmacy_get_recent_chats } from "../../../networking/urlEndPoints";
import Axios from '../../../networking/intraceptor'

// A single user action can trigger the direct chat refresh plus one or more
// presence/realtime refresh signals. Reuse an identical request that is already
// running so those signals do not create duplicate HTTP calls.
const recentChatRequestsInFlight = new Map();

export const fetchRecentChatListRequest = () => ({
	type: ADD_RECENT_CHATS_REQUEST,
})

export const fetchRecentChatListSuccess = (data) => ({
	type: ADD_RECENT_CHATS_SUCCESS,
	payload: data,
})

export const fetchRecentChatListFailure = (error) => ({
	type: ADD_RECENT_CHATS_FAILURE,
	payload: error,
})

export const fetchAllRecentChats = (setRecenetChatLoading, user_name) => {
	return async (dispatch) => {
		const normalizedUserName = typeof user_name === 'string' ? user_name.trim() : '';
		const requestKey = normalizedUserName.toLowerCase();
		const existingRequest = recentChatRequestsInFlight.get(requestKey);

		if (existingRequest) {
			try {
				await existingRequest;
			} catch (_) {
				// The request that owns the refresh dispatches the failure state.
			} finally {
				if (typeof setRecenetChatLoading === 'function') {
					setRecenetChatLoading(false);
				}
			}
			return;
		}

		dispatch(fetchRecentChatListRequest())
		try {
			const requestData = {}

			if (normalizedUserName) {
				requestData.user_name = normalizedUserName;
			}

			const request = Axios.post(`${pharmacy_get_recent_chats}`, requestData);
			recentChatRequestsInFlight.set(requestKey, request);
			const response = await request;

			if (response?.status === 200) {
				dispatch(fetchRecentChatListSuccess(response?.data))
				if (typeof setRecenetChatLoading === 'function') {
					setRecenetChatLoading(false)
				}
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(fetchRecentChatListFailure(error?.response))
			}
			if (typeof setRecenetChatLoading === 'function') {
				setRecenetChatLoading(false)
			}
		} finally {
			recentChatRequestsInFlight.delete(requestKey);
		}
	}
}
